import React from 'react';

export function appCreateContext<T = any>(defaultValue?: T): [React.Context<T>, () => T] {
  const context = React.createContext<T>(defaultValue);
  return [context, () => React.useContext(context)];
}
